import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export type ITypes = 'utc' | 'local'

export const getTimezoneOffset = (type: ITypes): string => {
  if (type === 'utc') {
    return ''
  }

  const localTimezone = dayjs(new Date()).format('Z')
  const timezoneOffset = localTimezone.slice(0, 3).replace(/^([+-])0/, '$1')

  if (timezoneOffset === '+0') {
    return ''
  }

  return timezoneOffset
}

/**
 * utc - date (2025-05-14 00:00:00+00)
 * example: dueDate, dateOfBirth
 *
 * local - datetime (2025-05-14 15:30:23.670862+00)
 * example: createdAt, sentAt
 */
export const formatDate = (
  date: string | Date,
  format: string,
  type: ITypes,
  showTimezone: boolean = false
): string => {
  if (!date) return ''

  let parsedDate: Date
  if (typeof date === 'string') {
    parsedDate = new Date(date)
  } else if (date instanceof Date) {
    parsedDate = date
  }

  if (isNaN(parsedDate.getTime())) {
    return ''
  }

  let convertedDate = dayjs.utc(parsedDate)
  if (type === 'local') {
    convertedDate = convertedDate.local()
  }

  const formattedDate = convertedDate.format(format)

  if (showTimezone) {
    const timezoneOffset = getTimezoneOffset(type)
    return `${formattedDate} (UTC${timezoneOffset})`
  }

  return formattedDate
}
